import { useEffect, useState } from 'react';

import FactDropdown from '../../../../../../components/organisms/FactDropdown';
import { Fact, Relevance } from '../../../../../../types';
import IncludeCheckbox from '../../components/IncludeCheckbox';
import { useSelectedFactsDb } from '../hooks/useSelectedFactsDb';

export function FactRow({
  fact,
  highlightedFactId,
  keyFactIdSet,
  setTotalNumberOfIncludedFacts,
  checkIfAllSelected,
  caseId,
  includedFactsCount,
}: {
  fact: Fact;
  highlightedFactId?: string;
  keyFactIdSet: Set<string>;
  setTotalNumberOfIncludedFacts: (v: number | ((prev: number) => number)) => void;
  checkIfAllSelected: (caseId: string) => void;
  caseId: string;
  includedFactsCount: number;
}) {
  const [isSelected, setIsSelected] = useState<boolean>();

  const { db, selectFact, deselectFact, isFactSelected, getAllSelectedIds } = useSelectedFactsDb();

  // Load initial checked state from database when the database is loaded
  useEffect(() => {
    async function loadCheckedState() {
      const selected = await isFactSelected(caseId, fact.id);
      setIsSelected(selected);
    }

    loadCheckedState();
  }, [db, includedFactsCount]);

  if (isSelected === undefined) return null;

  return (
    <div className="relative flex gap-3">
      <IncludeCheckbox
        included={isSelected}
        onClick={async (e) => {
          const toggleValue = e.target.checked;
          setIsSelected(toggleValue);

          if (toggleValue) {
            await selectFact(caseId, fact.id);
          } else {
            await deselectFact(caseId, fact.id);
          }

          setTotalNumberOfIncludedFacts((await getAllSelectedIds(caseId)).length);
          checkIfAllSelected(caseId);
        }}
        eventId={fact.id}
      />
      <div
        className={`w-full rounded-lg border ${
          highlightedFactId === fact.id
            ? `green-glow-card border-brandSecondary/${fact.relevance === Relevance.NO ? '80' : '50'}`
            : keyFactIdSet && keyFactIdSet.has(fact.id)
              ? `gold-glow-card border-yellow-300`
              : ''
        } ${fact.relevance === Relevance.NO ? 'border-dashed' : ''}`}
      >
        <FactDropdown fact={fact} isKey={keyFactIdSet.has(fact.id)} compressedVersion />
      </div>
    </div>
  );
}
